var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',[_c('product-checkout',{attrs:{"price":_vm.course ? _vm.course.price : null,"name":_vm.course ? _vm.course.name : null,"show-recert-disclaimer":true}}),_c('registration-questions',{attrs:{"questions":_vm.questions},on:{"submitted":_vm.onSubmit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }